import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, err: null };
  }
  static getDerivedStateFromError(err) {
    return { hasError: true, err };
  }
  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", err, info);
  }
  reset = () => this.setState({ hasError: false, err: null });
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="brut-card max-w-lg p-8 space-y-4">
          <h1 className="font-display font-bold text-2xl">Something went wrong.</h1>
          <p className="text-sm text-muted-foreground">
            One of the page components failed to render. The rest of the app is still safe.
          </p>
          <pre className="font-mono text-xs bg-muted p-3 rounded-md overflow-x-auto max-h-40">
            {String(this.state.err?.message || this.state.err || "unknown error")}
          </pre>
          <div className="flex gap-3">
            <button onClick={this.reset} className="signal-btn h-10 px-4 rounded-md text-sm font-semibold" data-testid="error-boundary-retry">
              Try again
            </button>
            <button onClick={() => (window.location.href = "/")} className="h-10 px-4 rounded-md border border-border text-sm hover:bg-muted">
              Home
            </button>
          </div>
        </div>
      </div>
    );
  }
}
